import { render, staticRenderFns } from "./bank-account-review-item.vue?vue&type=template&id=218c7feb&scoped=true&lang=pug"
import script from "./bank-account-review-item.vue?vue&type=script&lang=ts"
export * from "./bank-account-review-item.vue?vue&type=script&lang=ts"
import style0 from "./bank-account-review-item.vue?vue&type=style&index=0&id=218c7feb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218c7feb",
  null
  
)

export default component.exports